import {
    AnimationLoadingBaseController,
    DragonBonesResourceItem,
    IAnimationControllerConfiguration,
    ILoadingBaseController
} from "../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../modules/@denishussar/html5-game-engine";
import { PreloaderBackgroundController } from "../Common/PreloaderBackgroundController";
import { AnimationContents } from "../AnimationContents";
import { GameLogic } from "../../Logic/GameLogic";
import { scaleModal } from "../../Utils/DialogScale";
import { GameModel } from "../../Models/GameModel";
import { hook } from "../../Utils/Hooks";

export interface IPreloaderGameControllerOptions {
    test: string;
    preloader: boolean;
}

export class PreloaderGameController extends AnimationLoadingBaseController implements ILoadingBaseController {
    public $model: GameModel;
    private canvasDom: HTMLElement;
    private oldWidth: number = 0;
    private oldHeight: number = 0;

    public constructor(@Inject private _options: IPreloaderGameControllerOptions,
        @Inject private _gameLogic: GameLogic) {
        super("PreloaderGameController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.PRELOADER_SCREEN_JSON,
            libraryName: "preloader_screen",
            childControllers: {
                // StreetBackgroundController:{
                //     instanceName: "bg",
                //     controller: PreloaderBackgroundController
                // }
            }
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(0);
        this.setTextStyleByQuery('loading_text', {
            stroke: '#000000',
            strokeThickness: 16,
        })
        this.canvasDom = document.querySelector("#gameCanvas");
        if (this._options.preloader)
            setTimeout(this.resizeOnUpdate.bind(this), 500);
    }

    // protected onLandscape(): void {
    //     this.gotoAndStop("landscape");
    // }

    // protected onPortrait(): void {
    //     this.gotoAndStop("portrait");
    // }

    protected onUpdate(frameRate: number): void {

    }

    public onLoadingProgress(progress: number): void {
        this.gotoAndStopByQuery("preloader", Math.floor(progress * 21));
    }

    public onHide(): void {
        this.gotoAndStopByQuery("preloader", 0);
    }

    public onShow(): void {

    }
    private resizeOnUpdate() {
        const width = this.renderer.renderer.width;
        const height = this.renderer.renderer.height;
        if ((width != this.oldWidth) &&
            (height != this.oldHeight)
        ) {

            const scale = Math.min(width / 1000, height / 1000);

            if (hook.viewport && this.container) {
                console.log(hook)
                hook.viewport.x = this.renderer.renderer.width / 2;
                hook.viewport.y = this.renderer.renderer.height / 2;
            }
            this.onResize(width, height, scale);

            this.oldHeight = height;
            this.oldWidth = width;
            console.log("scaled", { width: width, height: height, scale: scale, viewX: hook.viewport.x, viewY: hook.viewport.y });
        }
        setTimeout(this.resizeOnUpdate.bind(this), 500);
    }

    protected onResize(width: number, height: number, scale: number) {
        // console.log(width, height, scale)
        let sizeW = width / scale;
        let sizeH = height / scale;
        scaleModal(this, width, height, scale, 1080, 1080);
        const bg = this.container.getChildByName("bg");
        bg.scale.x = bg.scale.y = Math.max(sizeH / 1080, sizeW / 1920) / this.scaleX;

    }
}
